// extracted by mini-css-extract-plugin
export default {"title":"title_title__Aa6dt","title_center":"title_title_center__WtHMS"};